// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchBaseStationSampleForPathImportCSV = () => (
  fetchWrapper('/documents/base-station-sample-path-import-file')
)

export const fetchCambiumSampleForPathImportCSV = () => (
  fetchWrapper('/documents/cambium-sample-path-import-file')
)

export const fetchPathLossSampleForPathImportCSV = () => (
  fetchWrapper('/documents/path-loss-sample-path-import-file')
)
export const fetchFrequencyMasterPlanURL = () => fetchWrapper('/documents/frequency-master-plan')
